export const GET_READ_POSTS = 'dashboard/GET_READ_POSTS';
export const GET_READ_POSTS_SUCCESS = 'dashboard/GET_READ_POSTS_SUCCESS';
export const GET_CONNECTIONS = 'dashboard/GET_CONNECTIONS';
export const GET_CONNECTIONS_SUCCESS = 'dashboard/GET_CONNECTIONS_SUCCESS';
export const GET_NOTICES = 'dashboard/GET_NOTICES';
export const GET_NOTICES_SUCCESS = 'dashboard/GET_NOTICES_SUCCESS';
// export const GET_EMERGENCY_BROADCAST_MESSAGE = 'dashboard/GET_EMERGENCY_BROADCAST_MESSAGE';
// export const GET_EMERGENCY_BROADCAST_MESSAGE_SUCCESS = 'dashboard/GET_EMERGENCY_BROADCAST_MESSAGE_SUCCESS'